module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/companies/company-logo-01-1d1f53c4d9cf81a93c5f51f7677b845b.png";